import { useEffect, useState } from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Constants from 'style/constants';

import MonitoringIcon from '../monitoring-icon';
import { MonitoringType } from '../monitoring-type';

import './monitoring-filter.scss';

type Props = {
  type?: MonitoringType;
  countColorOverride?: string;
  count: number;
  countColor?: string;
  isSelected: boolean;
  onSelected: (selected: boolean) => void;
  text: string;
};

const MonitoringFilter = ({
  type,
  countColorOverride,
  count,
  countColor,
  isSelected: isSelectedProp,
  onSelected,
  text,
}: Readonly<Props>): React.JSX.Element => {
  const [isSelected, setIsSelected] = useState<boolean>(isSelectedProp);

  const getColor = (): string | undefined => {
    if (countColorOverride) {
      return countColorOverride;
    }
    return count > 0 ? countColor : Constants.Colors.onSurface;
  };

  useEffect(() => {
    if (isSelected !== isSelectedProp) {
      setIsSelected(isSelectedProp);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSelectedProp]);

  return (
    <Grid
      container
      direction="column"
      className={`monitoring-filter-container ${isSelected ? 'selected' : ''}`}
      data-testid={`monitoring-filter-${type}`}
      onClick={() => {
        setIsSelected(!isSelected);
        onSelected(!isSelected);
      }}
      size="grow"
      sx={{
        flexWrap: 'nowrap',
        minWidth: 150,
      }}
    >
      <div className="text-row">
        {type && <MonitoringIcon type={type} withTooltip={false} visible={true} size={24} />}
        <Typography
          variant="subtitle1"
          sx={{
            color: Constants.Colors.onSurface,
          }}
          className="max-lines"
        >
          {text}
        </Typography>
      </div>
      <Typography
        variant="h2"
        sx={{
          color: getColor(),
        }}
      >
        {count}
      </Typography>
    </Grid>
  );
};

export default MonitoringFilter;
